export const formatPercentageToApi = (value: any) => {
  if (value === "" || undefined || null) return;
  if (String(value)?.endsWith("%")) {
    return parseFloat(String(value).replace(",",".").replace("%", ""));
  } else {
    return parseFloat(String(value).replace(",","."))
  }
}